export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "صندوق الرسائل",
    subtitle: "WhatsApp وكونسيرج الويب ومنصات OTA في مكان واحد",
  },

  channels: {
    all: "الكل",
    whatsapp: "WhatsApp",
    web: "الويب",
    ota: "OTA",
  },

  empty: {
    title: "لا توجد رسائل جديدة",
    description: "ستظهر رسائل الروبوت الجديدة هنا عند وصولها",
  },

  buttons: {
    markAll: "تحديد الكل كمقروء",
    goToChat: "إعداد وكيل الذكاء الاصطناعي",
    archive: "أرشفة المحادثة",
  },

  actions: {
    replyWhatsApp: "الرد عبر WhatsApp",
  },

  time: {
    now: "الآن",
    minuteSuffix: "د",
    hourSuffix: "س",
    daySuffix: "ي",
    today: "اليوم",
    yesterday: "أمس",
  },

  questions: {
    searchPlaceholder: "ابحث في الأسئلة...",
    answered: "تمت الإجابة",
    noAnswer: "معلّق",
    withImage: "يحتوي على صورة",
    empty: "لم يتم العثور على أسئلة",
    confirmDelete: "هل أنت متأكد أنك تريد حذف هذا السؤال؟",
  },

  answer: {
    assistantResponse: "رد المساعد",
    attachedImageOptional: "صورة مرفقة (اختياري)",
    uploadImage: "رفع صورة",
    clickToSelect: "انقر لاختيار صورة",
    changeImage: "تغيير الصورة",
    imagePreviewAlt: "معاينة الصورة",
    defaultImageName: "image.jpg",
  },

  phone: {
    online: "متصل",
    today: "اليوم",
    exampleQuestion: "سؤال نموذجي",
    writeAnswerPlaceholder: "اكتب إجابة لهذا السؤال...",
    writeMessagePlaceholder: "اكتب رسالة...",
    answerImageAlt: "صورة الإجابة",
    confirmDeleteImage: "حذف الصورة؟",
    imageDeletedSuccess: "تم حذف الصورة بنجاح.",
    virtualAssistant: "المساعد الافتراضي",
  },

  search: {
    placeholder: "ابحث بالاسم أو الهاتف أو رمز الحجز...",
    noResultsTitle: "لم يتم العثور على محادثات",
    noResultsDescription:
      "جرّب اسمًا أو رقم هاتف أو رمز حجز آخر.",
  },

  archive: {
    title: "أرشفة المحادثة",
    message:
      "إذا أرشفت هذه المحادثة، فستختفي من هذه القائمة. لا يزال بإمكانك الوصول إليها من الحجز المرتبط.",
    cancel: "إلغاء",
    confirm: "أرشفة",
  },
};

export default bot;
